import { useQueryClient } from "@tanstack/react-query";

import { candidateSheetV2TabCountsQueryKey } from "@/lib/constants";
import { novaClient } from "@/lib/trpc";

export function useDeleteRemoveUserNote() {
  const novaClientUtils = novaClient.useUtils();
  const queryClient = useQueryClient();

  return novaClient.internal.user.note.delete.useMutation({
    onSuccess: (deletedNote) => {
      novaClientUtils.internal.user.note.list.setData(
        { userId: deletedNote.userId },
        (cachedNotes) =>
          cachedNotes?.filter((cachedNote) => cachedNote.id !== deletedNote.id),
      );
      void queryClient.invalidateQueries({
        queryKey: candidateSheetV2TabCountsQueryKey,
      });
    },
  });
}
